import { LayoutMode } from "@/lib/videoGrouping";

const STORAGE_KEY_LAYOUT = "timeline-layout-mode";
const STORAGE_KEY_CARD_SIZE = "timeline-card-size";

function isValidLayoutMode(value: string): value is LayoutMode {
  return [
    "none",
    "horizontal-default",
    "horizontal-day",
    "horizontal-week",
    "horizontal-month",
  ].includes(value);
}

function isValidCardSize(value: string): value is 'large' | 'medium' | 'small' {
  return ["large", "medium", "small"].includes(value);
}

/**
 * Load saved preferences from localStorage
 */
export function loadTimelinePreferences(): {
  layoutMode: LayoutMode;
  cardSize: 'large' | 'medium' | 'small';
} {
  const savedLayout = localStorage.getItem(STORAGE_KEY_LAYOUT) as LayoutMode | null;
  const savedCardSize = localStorage.getItem(STORAGE_KEY_CARD_SIZE) as 'large' | 'medium' | 'small' | 'big' | null;

  // Migrate old 'big' value to 'large' (old 'small' no longer needs migration since 'small' is now valid)
  let migratedCardSize: 'large' | 'medium' | 'small' = 'medium';
  if (savedCardSize === 'big') {
    migratedCardSize = 'large';
  } else if (savedCardSize && isValidCardSize(savedCardSize)) {
    migratedCardSize = savedCardSize;
  }

  return {
    layoutMode: savedLayout && isValidLayoutMode(savedLayout) ? savedLayout : "none",
    cardSize: migratedCardSize,
  };
}
